import Swiper, { Lazy } from 'swiper';
Swiper.use([Lazy]);

const Home = {
  setDownArrow: function () {
    const arrows = document.querySelectorAll('[data-section-down]');

    arrows.forEach(arrow => {
      if (arrow) {
        arrow.addEventListener('click', () => {
          const section = arrow.closest('section');
          const nextSection = section.nextElementSibling;

          if (nextSection) {
            nextSection.scrollIntoView({
              behavior: 'smooth',
            });
          }
        });
      }
    });
  },
  init: function () {
    this.setDownArrow();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
